import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, Clock, MessageCircle } from 'lucide-react';
import { Button } from './Button';
export function Pricing() {
  // Countdown logic for pricing card
  const [timeLeft, setTimeLeft] = useState({
    hours: 4,
    minutes: 59,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            ...prev,
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="precio" className="py-20 bg-stone-50" data-id="element-109">
      <div className="container mx-auto px-4 md:px-6" data-id="element-110">
        <div className="max-w-lg mx-auto" data-id="element-111">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-gray-100 relative" data-id="element-112">
            {/* Urgency Badge */}
            <div className="absolute top-0 right-0 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg z-10" data-id="element-113">
              -60% OFF
            </div>

            <div className="bg-teal-600 p-6 text-center text-white" data-id="element-114">
              <h2 className="text-2xl font-bold mb-2" data-id="element-115">
                Plantilla de Finanzas Personales
              </h2>
              <p className="opacity-90" data-id="element-116">Oferta por tiempo limitado</p>
            </div>

            <div className="px-8 md:px-10 pt-6 pb-8 md:pt-8 md:pb-10" data-id="element-117">
              {/* Product Image - Inside white section */}
              <div className="mb-2" data-id="element-118">
                <img src="https://cdn.magicpatterns.com/uploads/aCbGv9Ta8whf6nYMwBmm7G/Logos_Verduleria_y_Fruteria_Simple_Verde_20260119_022532_0000.png" alt="Plantilla de Finanzas Personales en múltiples dispositivos" className="w-full h-auto" data-id="element-119" />
              </div>

              {/* Countdown Timer inside card */}
              <div className="mb-6 bg-red-50 border border-red-100 rounded-lg p-3 flex items-center justify-center gap-2 text-red-700 text-sm font-medium" data-id="element-120">
                <Clock className="w-4 h-4" data-id="element-121" />
                <span data-id="element-122">La oferta termina en:</span>
                <span className="font-mono font-bold text-base" data-id="element-123">
                  {String(timeLeft.hours).padStart(2, '0')}:
                  {String(timeLeft.minutes).padStart(2, '0')}:
                  {String(timeLeft.seconds).padStart(2, '0')}
                </span>
              </div>

              <div className="flex flex-col items-center mb-8" data-id="element-124">
                <span className="text-gray-400 line-through text-xl mb-1" data-id="element-125">
                  $49.990
                </span>
                <div className="flex items-baseline gap-1" data-id="element-126">
                  <span className="text-5xl font-bold text-gray-900" data-id="element-127">
                    $19.990
                  </span>
                  <span className="text-gray-500 font-medium" data-id="element-128">ARS</span>
                </div>
                <span className="inline-block mt-4 px-3 py-1 bg-teal-50 text-teal-700 text-xs font-bold rounded-full uppercase tracking-wide" data-id="element-129">
                  Pago Único • Acceso Inmediato
                </span>
              </div>

              <ul className="space-y-4 mb-8" data-id="element-130">
                {['Plantilla Editable en Google Sheets', 'Gestión de Ingresos y Gastos', 'Control de Ahorros y Deudas', 'BONUS: Planificador Imprimible', 'BONUS: Video Tutorial Paso a Paso', 'Acceso de por vida'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-131">
                    <Check className="w-5 h-5 text-teal-600 flex-shrink-0 mt-0.5" data-id="element-132" />
                    <span className="text-gray-700" data-id="element-133">{item}</span>
                  </li>)}
              </ul>

              <Button href="https://checkout.tuvidasimple.shop/cart/44058955939942:1" fullWidth className="mb-4" data-id="element-134">
                Acceder ahora por $19.990
              </Button>

              {/* WhatsApp Support Message */}
              <div className="mb-4 text-center" data-id="element-135">
                <p className="text-sm text-gray-700 mb-2" data-id="element-136">
                  💬 ¿Tuviste algún problema con el pago o con el acceso?
                </p>
                <a href="https://wa.link/ut4sjx" target="_blank" rel="noopener noreferrer" className="text-sm text-teal-600 hover:text-teal-700 font-medium underline inline-flex items-center gap-1" data-id="element-137">
                  <MessageCircle className="w-4 h-4" data-id="element-138" />
                  Escribinos por WhatsApp y te ayudamos en minutos
                </a>
              </div>

              {/* Digital Product Disclaimer */}
              <div className="text-center text-xs text-gray-400 mb-4 leading-relaxed" data-id="element-139">
                <p data-id="element-140">Producto digital – acceso inmediato.</p>
                <p data-id="element-141">
                  El acceso se envía automáticamente por email luego del pago.
                </p>
                <p data-id="element-142">No se envían productos físicos.</p>
              </div>

              <div className="flex items-center justify-center gap-2 text-xs text-gray-400" data-id="element-143">
                <ShieldCheck className="w-4 h-4" data-id="element-144" />
                <span data-id="element-145">Compra segura y garantizada</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}